import * as React from 'react';

import { useWidgetExpanderContext } from '.';

export const WidgetExpander: React.FC = () => {
  const { expandedBy } = useWidgetExpanderContext();
  return <div css={{ height: expandedBy }} />;
};
